import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";

const APPROACHES = [
  "Patient-focused drug development",
  "Patient experience evidence",
  "PRO / COA methodology",
  "Real-world evidence",
  "HTA and value assessment",
  "Evidence synthesis and qualitative research",
];

export default function MethodologicallyAnchored() {
  return (
    <section
      className="bg-ink-1 relative border-t border-white/[0.06]"
      data-testid="methodologically-anchored"
    >
      <div className="container-edge py-24 lg:py-32">
        <div className="grid grid-cols-12 gap-x-8 gap-y-12">
          <Reveal className="col-span-12 lg:col-span-5">
            <div className="eyebrow">Methodologically anchored</div>
            <h2 className="font-serif font-normal text-3xl md:text-5xl lg:text-[3.5rem] tracking-tight mt-4 text-parchment-bright leading-[1.05]">
              Voice2Evidence is informed by established approaches.
            </h2>
            <p
              className="mt-7 pt-6 border-t border-white/[0.10] text-parchment/75 text-[14.5px] leading-relaxed max-w-md"
              data-testid="methodology-trail-line"
            >
              Every engagement includes source anchoring, evidence triangulation, and expert validation.
            </p>
            <div className="mt-8">
              <Link
                to="/framework"
                className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-rust hover:text-parchment-bright transition-colors"
                data-testid="methodology-learn-more"
              >
                <span>Methodology · learn more</span>
                <span aria-hidden="true" className="text-[14px] leading-none">→</span>
              </Link>
            </div>
          </Reveal>

          <div className="col-span-12 lg:col-span-7">
            <Reveal>
              <div
                className="bg-ink-2 border border-white/[0.08] p-7 lg:p-9"
                data-testid="methodology-informed-by"
              >
                <div className="flex items-center gap-3 mb-6">
                  <span className="w-2 h-2 rounded-full bg-rust" aria-hidden="true" />
                  <span className="font-mono text-[10.5px] uppercase tracking-[0.22em] text-rust">
                    Informed by established approaches across
                  </span>
                </div>
                <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
                  {APPROACHES.map((item) => (
                    <li
                      key={item}
                      className="flex gap-3"
                      data-testid={`methodology-approach-${item.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                    >
                      <span className="mt-2 w-1 h-1 rounded-full bg-parchment/55 shrink-0" aria-hidden="true" />
                      <span className="font-serif text-[1.05rem] text-parchment-bright leading-snug">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal className="mt-7">
              <p className="text-parchment/55 leading-relaxed text-[12.5px] italic max-w-3xl">
                References to external frameworks and standards are provided for methodological orientation only and do not imply endorsement, certification, approval, or formal affiliation.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
